import React, { useState } from "react";
import { locations } from "../data/siteData";
import "./Contact.css";

const initialForm = {
  name: "",
  phone: "",
  email: "",
  location: locations[0].id,
  propertyType: "Independent House",
  message: "",
};

const PHONE_REGEX = /^(?:\+91[\s-]?)?[6-9]\d{9}$/;
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function validate(form) {
  const errors = {};
  if (form.name.trim().length < 2) {
    errors.name = "Name must be at least 2 characters.";
  }
  if (!PHONE_REGEX.test(form.phone.trim())) {
    errors.phone = "Enter a valid Indian phone number.";
  }
  if (!EMAIL_REGEX.test(form.email.trim())) {
    errors.email = "Enter a valid email address.";
  }
  if (form.message.trim().length < 10) {
    errors.message = "Message must be at least 10 characters.";
  }
  return errors;
}

export default function Contact() {
  const [form, setForm] = useState(initialForm);
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const [status, setStatus] = useState("idle"); // idle | success

  const update = (field) => (e) => {
    setForm((f) => ({ ...f, [field]: e.target.value }));
  };

  const blur = (field) => () => setTouched((t) => ({ ...t, [field]: true }));

  const handleSubmit = (e) => {
    e.preventDefault();
    const validation = validate(form);
    setErrors(validation);
    setTouched({
      name: true,
      phone: true,
      email: true,
      message: true,
    });
    if (Object.keys(validation).length === 0) {
      setStatus("success");
      setForm(initialForm);
      setTouched({});
    }
  };

  return (
    <section id="contact" className="contact section">
      <div className="container contact__grid">
        <div className="contact__info">
          <span className="eyebrow">Get In Touch</span>
          <h2 className="contact__title">
            LET&rsquo;S TALK <span className="glow-text">SOLAR</span>
          </h2>

          {locations.map((loc) => (
            <div className="contact__location" key={loc.id}>
              <span className="contact__location-code">{loc.code}</span>
              <h3>{loc.city}</h3>
              <p>{loc.address}</p>
              <p>{loc.phone}</p>
              <p>{loc.email}</p>
            </div>
          ))}
        </div>

        <form className="contact__form" onSubmit={handleSubmit} noValidate>
          {status === "success" && (
            <p className="contact__success" role="status">
              Thanks — your message has been received. Our team will reach
              out shortly.
            </p>
          )}

          <div className="contact__field">
            <label htmlFor="name">Name</label>
            <input
              id="name"
              type="text"
              value={form.name}
              onChange={update("name")}
              onBlur={blur("name")}
              aria-invalid={Boolean(touched.name && errors.name)}
            />
            {touched.name && errors.name && (
              <span className="contact__error">{errors.name}</span>
            )}
          </div>

          <div className="contact__field-row">
            <div className="contact__field">
              <label htmlFor="phone">Phone</label>
              <input
                id="phone"
                type="tel"
                value={form.phone}
                onChange={update("phone")}
                onBlur={blur("phone")}
                aria-invalid={Boolean(touched.phone && errors.phone)}
                placeholder="98765 43210"
              />
              {touched.phone && errors.phone && (
                <span className="contact__error">{errors.phone}</span>
              )}
            </div>

            <div className="contact__field">
              <label htmlFor="email">Email</label>
              <input
                id="email"
                type="email"
                value={form.email}
                onChange={update("email")}
                onBlur={blur("email")}
                aria-invalid={Boolean(touched.email && errors.email)}
              />
              {touched.email && errors.email && (
                <span className="contact__error">{errors.email}</span>
              )}
            </div>
          </div>

          <div className="contact__field-row">
            <div className="contact__field">
              <label htmlFor="location">Preferred location</label>
              <select id="location" value={form.location} onChange={update("location")}>
                {locations.map((loc) => (
                  <option value={loc.id} key={loc.id}>
                    {loc.city}
                  </option>
                ))}
              </select>
            </div>

            <div className="contact__field">
              <label htmlFor="propertyType">Property type</label>
              <select
                id="propertyType"
                value={form.propertyType}
                onChange={update("propertyType")}
              >
                <option>Independent House</option>
                <option>Apartment / Flat</option>
                <option>Commercial Unit</option>
              </select>
            </div>
          </div>

          <div className="contact__field">
            <label htmlFor="message">Message</label>
            <textarea
              id="message"
              rows={4}
              value={form.message}
              onChange={update("message")}
              onBlur={blur("message")}
              aria-invalid={Boolean(touched.message && errors.message)}
            />
            {touched.message && errors.message && (
              <span className="contact__error">{errors.message}</span>
            )}
          </div>

          <button type="submit" className="btn btn-primary contact__submit">
            Send Message
          </button>
        </form>
      </div>
    </section>
  );
}
